import React from 'react'

import UnidadComponentLoader from './UnidadComponentLoader'

const Mediacion = React.lazy(() => import('./mediacion/InfoPreliminar'))
const Correduria = React.lazy(() => import('./correduria/InfoPreliminar'))

export default function InfoPreliminar(params) {

    return (                     
        <UnidadComponentLoader 
            {...params}
            correduria={Correduria}
            mediacion={Mediacion}
        ></UnidadComponentLoader>       
    )

}